import React from 'react';
import { CheckIcon, MinusIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { SectionLabel } from './SectionLabel';
const forYou = ['Sos padre o madre que quiere mejorar su casa.', 'No tenés experiencia con herramientas.', 'Querés ahorrar dinero en arreglos simples.', 'Necesitás instrucciones claras y paso a paso.', 'Querés más independencia en tu hogar.', 'Tenés tareas pendientes hace meses.'];
const notForYou = ['Buscás remodelaciones o construcción avanzada.', 'Querés instalaciones eléctricas complejas.', 'Ya tenés experiencia en bricolaje.', 'No estás dispuesto a seguir medidas de seguridad.'];
export function ForWhom() {
  return <section aria-labelledby="para-vos-titulo" className="w-full border-y-2 border-ink bg-sand" data-id="element-51" data-mp="3hhwxlljeknd9">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:px-8 sm:py-24" data-id="element-52" data-mp="irwn7s6g2yt2">
        <Reveal data-id="element-53" data-mp="e0wtevsmgwus">
          <SectionLabel data-id="element-54" data-mp="e0em944f8y83">¿Es para vos?</SectionLabel>
          <h2 id="para-vos-titulo" className="mt-4 font-display text-3xl font-bold leading-tight sm:text-[2.6rem]" data-id="element-55" data-mp="dzlm4lzyx6yx">
            Vamos a ser honestos
          </h2>
        </Reveal>

        <div className="mt-10 grid gap-6 lg:grid-cols-2" data-id="element-56" data-mp="1t7vyozsjbctf">
          <Reveal data-id="element-57" data-mp="1fdvav134fa7u">
            <div className="h-full rounded-3xl border-2 border-ink bg-cream p-7 shadow-blockSm" data-id="element-58" data-mp="1feeinoz24i85">
              <h3 className="font-display text-2xl font-bold" data-id="element-59" data-mp="1kbwtxm0jr9jb">
                Este libro es para vos si…
              </h3>
              <ul className="mt-6 space-y-4" data-id="element-60" data-mp="1afjzglx6grni">
                {forYou.map(item => <li key={item} className="flex items-start gap-3" data-id="element-61" data-mp="1ad78jj9fz6yb">
                    <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-moss text-cream" data-id="element-62" data-mp="whd8lpqnbrxc">
                      <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-63" data-mp="11gq6r6mywlf8" />
                    </span>
                    <span className="text-[15px] leading-relaxed text-graphite" data-id="element-64" data-mp="2qrz2i0m8km9q">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </Reveal>

          <Reveal delay={0.08} data-id="element-65" data-mp="2pc4qukc0lvhn">
            <div className="h-full rounded-3xl border-2 border-ink/20 bg-cream/50 p-7" data-id="element-66" data-mp="2pbuwylnun46o">
              <h3 className="font-display text-2xl font-bold text-ink/70" data-id="element-67" data-mp="2kemj2x9qhmb8">
                No es para vos si…
              </h3>
              <ul className="mt-6 space-y-4" data-id="element-68" data-mp="2fgb98mjfvbt0">
                {notForYou.map(item => <li key={item} className="flex items-start gap-3" data-id="element-69" data-mp="3d1fjtfn4ill8">
                    <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full border-2 border-ink/20 text-ink/40" data-id="element-70" data-mp="384703ambu9hv">
                      <MinusIcon className="h-4 w-4" aria-hidden="true" data-id="element-71" data-mp="33acmmoxbeqr8" />
                    </span>
                    <span className="text-[15px] leading-relaxed text-graphite/80" data-id="element-72" data-mp="2ybi3flvfr06l">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
}